<div class="form-container">
  <h6 i18n>{{ title }}</h6>
  <p class="header-p" i18n>{{ desc }}</p>
  <form [formGroup]="changePasswordForm">
    @if (showExistingPassword) {
      <app-input
        [formCntlName]="oldPassword"
        [inputType]="oldPswdVisibility ? textInputType : passwordInputType"
        [label]="oldPasswordLabel"
        [prefixInputIcon]="lockIcon"
        [suffixInputIcon]="oldPswdVisibility ? visibilityIcon : visibilityOffIcon"
        (inputIconClickEvent)="handleOldPswdVisibilityCallback($event)"
        (keyup)="handleChange()"
        [maxLength]="32"
      ></app-input>
      @if (oldPassword.hasError('required') && oldPassword.touched) {
        <mat-error class="mat-error-msg" i18n>This field is required</mat-error>
      }
    }
    <app-input
      [formCntlName]="newPassword"
      [inputType]="newPswdVisibility ? textInputType : passwordInputType"
      [label]="newPasswordLabel"
      [prefixInputIcon]="lockIcon"
      [suffixInputIcon]="newPswdVisibility ? visibilityIcon : visibilityOffIcon"
      (inputIconClickEvent)="handleNewPswdVisibilityCallback($event)"
      (keyup)="handleChange()"
      [maxLength]="32"
    ></app-input>
    @if (newPassword.hasError('required') && newPassword.touched) {
      <mat-error class="mat-error-msg" i18n>This field is required</mat-error>
    }
    <app-input
      [formCntlName]="confirmPassword"
      [inputType]="confirmPswdVisibility ? textInputType : passwordInputType"
      [label]="confirmPasswordLabel"
      [prefixInputIcon]="lockIcon"
      [suffixInputIcon]="confirmPswdVisibility ? visibilityIcon : visibilityOffIcon"
      (inputIconClickEvent)="handleConfirmPswdVisibilityCallback($event)"
      (keyup)="handleChange()"
      [maxLength]="32"
    ></app-input>
    @if (confirmPassword.hasError('required') && confirmPassword.touched) {
      <mat-error class="mat-error-msg" style="top: 24.75em" i18n>This field is required</mat-error>
    } @else if ((confirmPassword.value ?? '').length > 0 && newPassword.value !== confirmPassword.value) {
      <mat-error class="mat-error-msg" style="top: 24.75em" i18n>Passwords do not match.</mat-error>
    }
    <div class="conditions">
      <span
        i18n
        class="password-rule checkbox-password-validator"
        [ngClass]="{
          valid: (newPassword.value ?? '').length >= 8 && (newPassword.value ?? '').length <= 32,
        }"
        ><p>
          <input
            type="checkbox"
            name="fr1"
            [checked]="(newPassword.value ?? '').length >= 8 && (newPassword.value ?? '').length <= 32"
            disabled
          />
        </p>
        <p>Password must be between 8 and 32 characters</p>
      </span>
      <span
        i18n
        class="password-rule checkbox-password-validator"
        [ngClass]="{ valid: hasUpperCase(newPassword.value ?? '') }"
      >
        <p><input type="checkbox" name="fr2" [checked]="hasUpperCase(newPassword.value ?? '')" disabled /></p>
        <p>Must contain an uppercase character</p>
      </span>
      <span
        i18n
        class="password-rule checkbox-password-validator"
        [ngClass]="{ valid: hasNumber(newPassword.value ?? '') }"
      >
        <p><input type="checkbox" name="fr3" [checked]="hasNumber(newPassword.value ?? '')" disabled /></p>
        <p>Must contain a number</p>
      </span>
      <span
        i18n
        class="password-rule checkbox-password-validator"
        [ngClass]="{ valid: hasSplChar(newPassword.value ?? '') }"
      >
        <p><input type="checkbox" name="fr4" [checked]="hasSplChar(newPassword.value ?? '')" disabled /></p>
        <p>Must contain one special character</p>
      </span>
    </div>
    @if (showSubmitButton) {
      <div class="submitBtn">
        <app-button
          class="flow-cta"
          [fullWidth]="true"
          [disabled]="!isChangePasswordFormValid"
          (click)="handleSubmit($event)"
        >
          {{ buttonSubmit }}
        </app-button>
      </div>
    }
    <div class="btn-class">
      @if (showCancelButton) {
        <app-buttons
          [isDisabled]="false"
          [name]="buttonCancel"
          [arialLabel]="arialLabel"
          [buttonType]="btnMat"
          [buttonStyle]="btnStyleText"
          (buttonClickEvent)="handleCancel($event)"
        ></app-buttons>
      }
      @if (showSaveButton) {
        <app-buttons
          [isDisabled]="!isChangePasswordFormValid"
          [name]="buttonSave"
          [buttonType]="btnMatFlat"
          [buttonStyle]="!isChangePasswordFormValid ? btnStyleFilledSmallDisabled : btnStyleFilledSmall"
          (buttonClickEvent)="handleSave($event)"
        ></app-buttons>
      }
    </div>
  </form>
</div>
